import gql from "graphql-tag"
import { graphql } from "react-apollo"
import PropTypes from "prop-types"

import UnitDropdown from "."

const query = gql`
  query UnitList($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      units {
        id
        name
      }
    }
  }
`
const UnitDropdownWithData = graphql(query, {
  options: props => ({
    variables: {
      facilityId: props.facilityId,
    },
  }),
  props: ({ data: { error, loading, facility }, ownProps }) => {
    if (error) {
      throw error
    }
    if (loading) {
      return { loading }
    }
    if (!facility) {
      error = Error("No facility with id " + ownProps.facilityId + " available")
      error.number = 204
      throw error
    }
    return {
      units: [
        {
          label: "All Units",
          value: null,
        },
      ].concat(
        facility.units
          .map(unit => ({
            value: unit.id,
            label: unit.name,
          }))
          .sort((unitA, unitB) => unitA.label.localeCompare(unitB.label))
      ),
      ...ownProps,
    }
  },
})(UnitDropdown)

UnitDropdownWithData.propTypes = {
  facilityId: PropTypes.string.isRequired,
  unitUpdated: PropTypes.func,
}

export default UnitDropdownWithData
